/*
 * Shared product-card behaviour (snippets/mn-product-card.liquid): quick add to cart.
 * Delegated on document so cards added later (infinite scroll, recommendations, recently viewed) work too.
 */
if (!window.mnQuickAdd) {
    window.mnQuickAdd = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mn-quick-add]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      btn.disabled = true;
      btn.classList.add('is-loading');
      fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.mnQuickAdd), quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message);
          if (window.theme && theme.settings && theme.settings.cartType === 'page') {
            window.location = (window.theme && theme.routes && theme.routes.cartPage) || '/cart';
            return;
          }
          // Impulse rebuilds and opens its cart drawer on this event
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: res.data.items && res.data.items[0] } }));
          btn.classList.add('is-added');
          setTimeout(function () { btn.classList.remove('is-added'); }, 1500);
        })
        .catch(function (err) {
          window.alert(err.message || 'Could not add to cart');
        })
        .finally(function () {
          btn.disabled = false;
          btn.classList.remove('is-loading');
        });
    });
  }
